<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-dialog
    v-model="timePickerDialog"
    max-width="400px"
  >
    <template #activator="{on,attr}">
      <v-card
        :class="'pa-3 '+cardClass"
        :color="color"
        class="d-flex align-center px-4 overflow-hidden"
        elevation="0"
        v-bind="attr"
        v-on="on"
      >
        <v-icon class="mr-2 mt-1">
          mdi-calendar-sync-outline
        </v-icon>
        <v-spacer />
        <div class="text-truncate">
          {{ dateDisplay | niceLabel }}
        </div>
      </v-card>
    </template>
    <v-card
      class="pa-6"
      color="#f6f6f6"
    >
      <normal-date-picker
        :need-max="needMax"
        :show-tag="showTag"
        v-model="realValue"
      />
      <v-btn
        block
        class="mt-4"
        color="amber lighten-4 black--text"
        elevation="0"
        rounded
        x-large
        @click="confirmDate"
      >
        {{ $t('confirm') }}
        <v-icon
          right
        >
          mdi-check
        </v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import { today } from '@/model/utils/DateRepository'
import NormalDatePicker from '@/views/widget/commonLogic/NormalDatePicker.vue'

export default {
  name: 'DatePickerInput',
  components: {
    NormalDatePicker
  },
  props: {
    color: {},
    value: {},
    cardClass: {},
    showTag: {
      type: Boolean,
      default: true
    },
    needMax: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      dateDisplay: [today, today],
      realValue: [today, today],
      timePickerDialog: false
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val, old) {
        this.realValue = val
      }
    }
  },
  methods: {
    confirmDate () {
      this.$emit('input', this.realValue)
      this.dateDisplay = this.realValue
      this.timePickerDialog = false
    }
  }
}
</script>

<style scoped>

</style>
